import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';

import {
    lotteryAnimationPathMapping,
    lotteryOpenPathParams,
    lotteryParticipantTypes
} from 'config/promoLotteryTypes';
import { isNoResultPageGames } from 'config/promoGameTypesClientConfig';
import { setAnimatingLotteries } from 'client/redux/modules/flags';

export const LOTTERY = 'lottery'; // params: lotteries?, prizeUUID, entriesUUID
export const PRIZE = 'prize'; // params: prizeUUID, entriesUUID
export const RESULT = 'result';
export const JOIN = 'join';
export const TRANSITION = 'transition';
export const UPLOAD = 'upload';
export const SIGNUP_FORM = 'form/signup';
export const REDEEM_FORM = 'form/redeem'; // params: formId, prizeUUID, entriesUUID
export const NOT_FOUND = '/notfound';

export default function useClientHistory() {
    const dispatch = useDispatch();
    const history = useHistory();
    const currentLocation = useLocation();
    const { promoUUID, promoId } = useParams();
    const { type: gameType } = useSelector(s => s.promo);

    function generatePath(
        pathType,
        { animatingLottery, prizeUUID, entriesUUID, formId } = {},
        location
    ) {
        const { search, hash } = location || window.location;
        let path = pathType;

        switch (pathType) {
            case LOTTERY: {
                if (animatingLottery) {
                    dispatch(setAnimatingLotteries(animatingLottery));
                }
                if (animatingLottery.type === lotteryParticipantTypes.PICK_THE_PRIZE) {
                    return getFullPath(
                        path +
                            `/${lotteryAnimationPathMapping[animatingLottery.type]}/${entriesUUID}`
                    );
                } else {
                    return getFullPath(
                        path +
                            `/${
                                lotteryAnimationPathMapping[animatingLottery.type] ||
                                lotteryOpenPathParams.GENERAL
                            }/${prizeUUID}/${entriesUUID}`
                    );
                }
            }
            case PRIZE:
                return getFullPath(path + `/${prizeUUID}/${entriesUUID}`);
            case REDEEM_FORM:
                return getFullPath(path + `/${formId}/${prizeUUID}/${entriesUUID}`);
            case RESULT:
                return getFullPath(isNoResultPageGames(gameType) ? JOIN : RESULT);
            default:
                return getFullPath(path);
        }

        function getFullPath(p) {
            return (p[0] === '/' ? p : `/${promoUUID}/${promoId}/${p}`) + `${search}${hash}`;
        }
    }
    function getRouteTransitionClassname(targetPath) {
        const currentPath = currentLocation.pathname;
        switch (true) {
            case targetPath === JOIN:
            case targetPath === TRANSITION:
            case targetPath === UPLOAD:
            case targetPath === RESULT && currentPath.includes(PRIZE):
            case targetPath === RESULT && currentPath.includes(SIGNUP_FORM):
            case targetPath === PRIZE && currentPath.includes(REDEEM_FORM):
                return 'fever-fade-prev';
            default:
                return 'fever-fade-next';
        }
    }
    function redirectPath(method, pathType, params, location) {
        const path = generatePath(pathType, params, location);
        const transition = getRouteTransitionClassname(pathType);
        history[method](path, { transition });
    }

    return {
        push: (pathType, params, location) => redirectPath('push', pathType, params, location),
        replace: (pathType, params, location) =>
            redirectPath('replace', pathType, params, location),
        originalPush: (...args) => history.push(...args),
        originalReplace: (...args) => history.replace(...args)
    };
}
